import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.modal');
import { HostListener, Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-season-modal',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.modal/view.scss */
:host {
  --modal-ink: #243a32;
  --modal-muted: #6e7d77;
  --modal-line: #e3e9e6;
  display: contents;
}

.season-modal-root {
  position: fixed;
  z-index: 1000;
  inset: 0;
}

.season-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(19, 31, 27, 0.48);
  backdrop-filter: blur(4px);
  animation: season-modal-fade-in 0.16s ease-out both;
}

.season-modal-viewport {
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 28px 20px;
  place-items: center;
}

.season-modal-card {
  position: relative;
  width: min(440px, 100%);
  overflow: hidden;
  box-sizing: border-box;
  padding: 26px;
  border: 1px solid rgba(221, 230, 226, 0.92);
  border-radius: 18px;
  color: var(--modal-ink);
  background: #fff;
  box-shadow: 0 24px 70px rgba(14, 31, 25, 0.22), 0 3px 12px rgba(14, 31, 25, 0.08);
  animation: season-modal-enter 0.2s cubic-bezier(0.2, 0.78, 0.3, 1) both;
}

.season-modal-accent {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 3px;
  background: #a84c46;
}

.season-modal-card.status-warning .season-modal-accent {
  background: #c58a2d;
}

.season-modal-card.status-success .season-modal-accent {
  background: #287b60;
}

.season-modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 34px;
  height: 34px;
  display: grid;
  padding: 0;
  border: 0;
  border-radius: 9px;
  place-items: center;
  color: #73817c;
  background: transparent;
  cursor: pointer;
  transition: color 0.15s ease, background 0.15s ease;
}

.season-modal-close:hover {
  color: #334a41;
  background: #f0f4f2;
}

.season-modal-close:focus-visible,
.season-modal-button:focus-visible {
  outline: 2px solid #438c73;
  outline-offset: 2px;
}

.season-modal-close svg {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-width: 1.8;
}

.season-modal-header {
  min-width: 0;
  display: flex;
  align-items: flex-start;
  padding-right: 34px;
  gap: 14px;
}

.season-modal-icon {
  width: 44px;
  height: 44px;
  display: grid;
  flex: 0 0 44px;
  border-radius: 13px;
  place-items: center;
  color: #a34843;
  background: #fbecea;
}

.status-warning .season-modal-icon {
  color: #9a681c;
  background: #fff3d9;
}

.status-success .season-modal-icon {
  color: #16694f;
  background: #e5f2ed;
}

.season-modal-icon svg {
  width: 23px;
  height: 23px;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.7;
}

.season-modal-heading {
  min-width: 0;
  padding-top: 1px;
}

.season-modal-kicker {
  display: block;
  margin-bottom: 4px;
  color: #a34843;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.status-warning .season-modal-kicker {
  color: #95661f;
}

.status-success .season-modal-kicker {
  color: #1c6e55;
}

.season-modal-heading h2 {
  margin: 0;
  color: var(--modal-ink);
  font-size: 19px;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: -0.025em;
}

.season-modal-message {
  margin: 18px 0 0;
  color: var(--modal-muted);
  font-size: 13px;
  line-height: 1.7;
  white-space: break-spaces;
  word-break: keep-all;
}

.season-modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 22px;
  border-top: 1px solid var(--modal-line);
  margin-top: 24px;
  gap: 9px;
}

.season-modal-button {
  min-width: 82px;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 15px;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  font-weight: 750;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.season-modal-button:active {
  transform: translateY(1px);
}

.season-modal-cancel {
  border-color: #d8e0dc;
  color: #50635b;
  background: #fff;
}

.season-modal-cancel:hover {
  border-color: #c8d3ce;
  background: #f5f8f7;
}

.season-modal-primary {
  color: #fff;
  background: #2b745c;
  box-shadow: 0 2px 5px rgba(23, 92, 69, 0.18);
}

.season-modal-primary:hover {
  background: #22664f;
}

.season-modal-primary.is-error {
  background: #a84c46;
  box-shadow: 0 2px 5px rgba(139, 54, 49, 0.18);
}

.season-modal-primary.is-error:hover {
  background: #943f3a;
}

.season-modal-primary.is-warning {
  color: #fff;
  background: #a9701d;
  box-shadow: 0 2px 5px rgba(146, 95, 21, 0.17);
}

.season-modal-primary.is-warning:hover {
  background: #956118;
}

.season-modal-primary.is-success {
  background: #287b60;
}

.season-modal-primary.is-success:hover {
  background: #1f6b52;
}

@keyframes season-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes season-modal-enter {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 560px) {
  .season-modal-viewport {
    align-items: end;
    padding: 0;
  }
  .season-modal-card {
    width: 100%;
    padding: 24px 20px calc(20px + env(safe-area-inset-bottom));
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    border-radius: 20px 20px 0 0;
  }
  .season-modal-heading h2 {
    font-size: 18px;
  }
  .season-modal-message {
    font-size: 13px;
  }
  .season-modal-actions {
    align-items: stretch;
    flex-direction: column-reverse;
  }
  .season-modal-button {
    width: 100%;
    min-height: 44px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .season-modal-backdrop,
  .season-modal-card {
    animation: none;
  }
}`],
})
export class PortalSeasonModalComponent implements OnInit {
    @Input() model: any = null;

    constructor(@Inject( Service) public service: Service) {
        if (!this.model) this.model = service.modal;
    }

    public async ngOnInit() {
    }

    public statusLabel() {
        if (this.model.opts.status === 'success') return '완료';
        if (this.model.opts.status === 'warning') return '주의';
        return '확인 필요';
    }

    public statusTitle() {
        if (this.model.opts.status === 'success') return '작업을 완료했습니다.';
        if (this.model.opts.status === 'warning') return '확인해 주세요.';
        return '처리 내용을 확인해 주세요.';
    }

    public async cancel() {
        if (!this.model || !this.model.isshow) return;
        if (typeof this.model.cancel === 'function') {
            await this.model.cancel();
            return;
        }
        await this.model.hide();
    }

    @HostListener('document:keydown.escape')
    public async onEscape() {
        if (!this.model || !this.model.isshow || !this.model.opts.cancel) return;
        await this.cancel();
    }
}

export default PortalSeasonModalComponent;